/** Cost types a budget line can be grouped under - the same two the Budget screen offers. */
export const BUDGET_COST_TYPES = ['Soft costs', 'Hard costs']

/**
 * Section key repeated once per bathroom on the loan. A template that keeps it behaves like the
 * original built-in budget; a template without it simply has no per-bathroom sections.
 */
export const BATHROOM_SECTION_KEY = 'bath'

/** Turn a label into a stable key for a section or line item. */
export const slugifyBudgetKey = (label: string): string => {
  const parts = label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .filter((v) => !!v)

  if (!parts.length) return ''
  return parts.map((part, index) => (index === 0 ? part : part[0].toUpperCase() + part.slice(1))).join('')
}

/** Append a numeric suffix until the key is unused. */
export const uniqueBudgetKey = (base: string, taken: string[]): string => {
  if (!taken.includes(base)) return base
  let index = 2
  while (taken.includes(`${base}${index}`)) index++
  return `${base}${index}`
}

/**
 * Key for a whole template. Snake_case to match the backend's own slug for templates added through
 * `budgetTemplates/add`, so keys look the same however a template was created. Section and line-item
 * keys use `slugifyBudgetKey` instead - those are camelCase, like the built-in template's.
 */
export const slugifyTemplateKey = (title: string): string =>
  String(title || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
